import { BaseFileFiledDto } from '@diritto/common/base/base.dto';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { PartnerProfileImage } from 'app-components/accounts/partners/PartnerProfileImage';
import { getTextLineStyle } from 'styles/common';

export interface PartnerProfileMenuItemProps {
  className?: string;
  nickname?: string;
  size?: number;
  file?: BaseFileFiledDto;
  fontWeight?: number;
  children?: React.ReactNode;
  inboxCount?: number;
  onClick?: () => void;
}

export const PartnerProfileMenuItem = ({
  className,
  nickname,
  file,
  size,
  fontWeight,
  inboxCount = 0,
  onClick,
  children,
}: PartnerProfileMenuItemProps) => (
  <StyledWrapper className={className} fontWeight={fontWeight} onClick={onClick}>
    {inboxCount > 0 && <StyledMark />}
    <PartnerProfileImage file={file} size={size} />
    <div className="flex flex-row text-center gap-[2px]">
      <p>{nickname}</p>
      <span>{children}</span>
    </div>
  </StyledWrapper>
);

const StyledWrapper = styled.div(
  ({ fontWeight }: PartnerProfileMenuItemProps) => css`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 12px 16px;
    position: relative;

    & > div > p {
      margin-left: 8px;
      font-weight: ${fontWeight || FontWeight.Medium};
      ${Typography.XXSmall};
      ${getTextLineStyle()};
      flex: 1;
    }

    &:hover {
      background-color: ${Color.Primary100};
    }
  `,
);

const StyledMark = styled.div`
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${Color.Red500};
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
`;
